import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import { useState, useRef } from 'react';
import BookUseListArea from "./area/book_use_list";

function TextbookStuUseListArea(props: any) {
  let myProps = {
    s_subject:"",
    ...props
  };
  const findStudentListRef = useRef<any>(null);
  const BookUseListAreaRef = useRef<any>(null);

  return (
    <div className="flex flex-row" style={{ gap: 15 }}>
      <div style={{ minWidth: 360 }} >
        <FindStudentList
          ref={findStudentListRef}
          list={(inData: any) => {
            //inData.s_stu_user_seq
            if (BookUseListAreaRef.current) {
              if (inData.s_stu_user_seq.length == 1) {
                BookUseListAreaRef.current.setInitData({ stu_seq: inData.s_stu_user_seq[0] });
              }
            }
          }}
          grid_opt={{
            rowMultiSelectWithClick: false,
          }}
          listOpt={{
            s_addon_textbook_use: "1",
            s_addon_textbook_use_addon_book: "",
            s_addon_textbook_use_addon_order_det: "",
            s_addon_textbook_use_s_in_now_period: "1",
            s_addon_textbook_use_s_subject: myProps.s_subject,
          }}
          show_key_arr={["row_view_textbook_use"]}
        ></FindStudentList>
      </div>
      <div style={{ flexGrow: 1, minWidth: 400 }}>
        <BookUseListArea
          ref={BookUseListAreaRef}
          s_subject={myProps.s_subject}
          callBackRefreshData={(inData:any)=>{
            if(findStudentListRef.current){
              findStudentListRef.current.list(inData);
            }
          }}
        ></BookUseListArea>
      </div>
    </div>
  );
};
export default TextbookStuUseListArea;